import { render, staticRenderFns } from "./LedesCodeType.vue?vue&type=template&id=b2ae0d16&"
import script from "./LedesCodeType.vue?vue&type=script&lang=js&"
export * from "./LedesCodeType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports